export default __webpack_public_path__ + "static/media/AloeAvatar.ca6037ec.png";